// extracted by mini-css-extract-plugin
export default {"mobile_modal":"TariffsModalMobile__mobile_modal--3xxDN","closeButton_mobile":"TariffsModalMobile__closeButton_mobile--GdBus"};